export interface AccountingSyncToolbarButton {
  key: string;
  link: string;
  /** Estado API; omitir para “Todos” */
  status?: string;
}

export const accountingSyncToolbarButtons: AccountingSyncToolbarButton[] = [
  { key: 'all', link: '#' },
  { key: 'pending', link: '#', status: 'pending' },
  { key: 'synced', link: '#', status: 'synced' },
  { key: 'failed', link: '#', status: 'failed' },
  { key: 'skipped', link: '#', status: 'skipped' },
];
